import axios from 'axios';
import { Message } from 'element-ui';
import { UserModule } from '@/store/modules/user';
import router from '@/router';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 10000,
  // withCredentials: true // send cookies when cross-domain requests
});

// Response interceptors
service.interceptors.response.use(
  (response) => {
    /* eslint-disable */
    const res = response.data;
    if (response.status !== 200) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000,
      });
      return Promise.reject(new Error(res.message || 'Error'));
    }
    return response;
  },
  (error) => {
    const res = error.response;
    if (res.data.error === 'invalid_token' || res.status === 401) {
      UserModule.ResetToken();
      router.push('/login');
    } else if (res.data.error === 'invalid_grant') {
      Message({
        message: res.data.error_description,
        type: 'error',
        duration: 5 * 1000,
      });      
    } else {
      Message({
        message: res.data.message,
        type: 'error',
        duration: 5 * 1000,
      });
      return Promise.reject(error);
    }
  },
);

export default service;
